module.exports = __webpack_public_path__ + "img/billboard_icon2.235e256f.png";